/*
 * @file: product.js
 * @description: Reducers and actions
 * @author: navreet
 */

import * as TYPE from '../../actions/constants'

/******** Reducers ********/
const initialState = {
    data: null,
    loggedIn: false,
    role: null,
    other_profile: null,
    is_mobile: false,
    forgot_email: null,
    checked: false,
    email: null,
    password: null,
    token: null,
    user_list: [],
    total_users: 0,
    pageNumber: 0,
    nextPage: 0,
    loginButtonDisable: false,
    errorStatus: false,
    errorMessage: '',
    last_login_admin:true,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case TYPE.ROLE_SET:
            return { ...state, role: action.role }
        case TYPE.ERROR_STATUS:
            return { ...state, errorStatus: action.data, errorMessage: action.message }
        case TYPE.LAST_LOGIN:
            return { ...state, last_login_admin:action.data , data:{...state.data , last_login_at:1 }}
        case TYPE.LOGIN_SUCCESS:
            return {
                ...state,
                data: action.data,
                email: action.email,
                password: action.password,
                token: action.token,
                checked: action.checked,
                loggedIn: true,
            }
        case TYPE.UPDATE_PROFILE:
            return { ...state, data: { ...state.data, ...action.data } }
        case TYPE.UPDATE_OTHER_PROFILE:
            return { ...state, other_profile: action.data }
        case TYPE.SET_MOBILE:
            return { ...state, is_mobile: action.data }
        case TYPE.LOGIN_BUTTON:
            return { ...state, loginButtonDisable: action.data }
        case TYPE.FORGOT_EMAIL:
            return { ...state, forgot_email: action.data }
        case TYPE.USER_LIST:
            return {
                ...state,
                user_list: action.data,
                pageNumber: action.res.previousPage + 1,
                nextPage: action.res.nextPage,
                total_users: action.res.total,
            }

        case TYPE.LOG_OUT:
            return {
                ...initialState,
                checked: state.checked,
                email: state.email,
                password: state.password,
            }
        default:
            return state
    }
}
